import { useContext } from "react";
import { useLogEvent } from "@app/neva/hooks/useLogEvent";
import { NevaContext } from "@app/neva/provider";
import { getNevaHeapVideoEvents } from "@app/neva/helpers/getNevaHeapVideoEvents";
import { IVideo } from "@app/components/videoPlayer";
import { NEVA_HEAP_EVENTS } from "@app/neva/models/constants";

type UseBindNevaHeapVideoController = {
  bindNevaHeapVideo: (video$: IVideo, title: string) => void;
};

export const useBindNevaHeapVideo = (): UseBindNevaHeapVideoController => {
  const { logEvent } = useLogEvent();
  const { botId } = useContext(NevaContext);
  const heapVideoEvents = getNevaHeapVideoEvents(botId);

  const bindNevaHeapVideo = (video$: IVideo, title: string) => {
    if (!heapVideoEvents) {
      return;
    }
    const { videoContent } = heapVideoEvents;
    const oneQuarterPlayed = Math.floor(video$.duration() / 4);
    const twoQuartersPlayed = Math.floor(video$.duration() / 2);
    const threeQuartersPlayed = oneQuarterPlayed * 3;

    video$.bind("secondchange", (videoProgress) => {
      switch (videoProgress) {
        case oneQuarterPlayed:
          logEvent({
            eventAction: NEVA_HEAP_EVENTS.UPP_VIDEO25PERC,
            eventLabel: "User Action",
            video_content: videoContent,
          });
          break;
        case twoQuartersPlayed:
          logEvent({
            eventAction: NEVA_HEAP_EVENTS.UPP_VIDEO50PERC,
            eventLabel: "User Action",
            video_content: videoContent,
          });
          break;
        case threeQuartersPlayed:
          logEvent({
            eventAction: NEVA_HEAP_EVENTS.UPP_VIDEO75PERC,
            eventLabel: "User Action",
            video_content: videoContent,
          });
          break;
      }
    });

    video$.bind("end", () => {
      logEvent({
        eventAction: NEVA_HEAP_EVENTS.UPP_VIDEO100PERC,
        eventLabel: "User Action",
        video_content: videoContent,
      });
    });

    video$.bind("play", () => {
      logEvent({
        eventAction: NEVA_HEAP_EVENTS.VIDEO_CLICK,
        eventLabel: "User Action",
        video_content: `${videoContent}, ${title}`,
      });
    });
  };

  return {
    bindNevaHeapVideo,
  };
};
